import { ActualizationTour, VisaFee, ResourceData, Resource, OilTax,
    Services as TourServices
} from 'sletat-api-services/lib/module/tourActualization/models';

export { TourService, ResourceTypes } from 'sletat-api-services/lib/module/tourActualization/models';
export { currency } from 'sletat-api-services/lib/types';
export { HotelInStop } from 'sletat-api-services/lib/Tour';
export { CurrencyId } from 'sletat-api-services/lib/types';

export enum ActualizationStatus {
    Initial = 'initial',
    InProcess = 'in_process',
    Success = 'success',
    Failed = 'failed',
    TourNotFound = 'tour_not_found'
}

export enum TourPriceStatus {
    Default = 'default',
    Pending = 'pending',
    NotSupportedOnlineBilling = 'not_supported_online_billing',
    Sold = 'sold',
    CheckedOnline = 'checked_online',
    QuickBooking = 'quick_booking',
    ExtraPay = 'extra_pay'
}

export interface ActualizationData {
    oilTaxes: OilTax[];
    resourceData: ResourceData[];
    resources: Resource[];
    visaFees: VisaFee[];
    services: TourServices;
    isDetailedExists: boolean;
    tour: ActualizationTour | null;
    originTourId: number | null;
    originTourPrice: number | null;
}
